import React from 'react';
import {connect} from 'react-redux';
import PageTransition from 'react-router-page-transition';

import GoogleTagManager from '../GoogleTagManager';

import {getUserAction, getUserStatsAction} from '../../actions/User';
import {getCategories} from '../../actions/Category';
import {getPackages, getUserPackages} from '../../actions/Package';
import {loadingDone} from '../../actions/Util';
import {getMeditations} from '../../actions/Meditation';
import CookieDisclaimer from '../Containers/CookieDisclamer';
import Overlay from '../Presentation/Overlay';
import Popup from '../Popups/Popup';

class BlankPage extends React.Component {

    constructor(props) {
        super(props);

        this.dataToBeLoaded = [];
        this.fetchData();
    }

    fetchData(props = this.props) {
        dispatchGetCategories(this.props.dispatch, props);
    }

    componentWillReceiveProps(nextProps) {
        const userJustLoggedIn = !this.props.authenticated && nextProps.authenticated;
        if (userJustLoggedIn) {
            this.fetchData(nextProps);
        }
    }

    render() {

        //In the case of IE the page transitions need to be disabled
        const isIE = /*@cc_on!@*/false || !!document.documentMode;

        return <div>
            <GoogleTagManager/>
            <CookieDisclaimer />
            {!isIE ? <PageTransition timeout={600}>{this.props.children}</PageTransition> : this.props.children}
            <Overlay active={this.props.showOverlay}/>
            <Popup />
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        authenticated: state.auth.authenticated,

        userDataPending: state.user.userDataPending,
        userDataFetched: state.user.userDataFetched,

        userStatsPending: state.user.userStatsPending,
        userStatsFetched: state.user.userStatsFetched,

        categoriesPending: state.category.getCategoriesPending,
        categoriesFetched: state.category.getCategoriesFetched,

        packagesPending: state.packages.packagesPending,
        packagesFetched: state.packages.packagesFetched,

        meditationsPending: state.packages.userMeditationsPending,
        meditationsFetched: state.packages.userMeditationsFetched,

        userPackagesPending: state.packages.userPackagesPending,
        userPackagesFetched: state.packages.userPackagesFetched,

        showOverlay: state.popup.showOverlay
    }
};

const dispatchGetCategories = (dispatch, props) => {
    const {categoriesPending, categoriesFetched} = props;
    if (!categoriesPending && !categoriesFetched) {
        dispatch(getCategories(dispatchGetCategories.bind(null, dispatch, props)))
            .then(() => dispatchGetAuthedDataSequence(dispatch, props))
    }
    else if (categoriesFetched) {
        dispatchGetAuthedDataSequence(dispatch, props);
    }
};

const dispatchGetAuthedDataSequence = (dispatch, props) => {
    const {authenticated} = props;
    if (authenticated) {
        dispatchGetPackages(dispatch, props);
    }
};

const dispatchGetPackages = (dispatch, props) => {
    const {packagesPending, packagesFetched} = props;
    if (!packagesPending && !packagesFetched) {
        dispatch(getPackages(dispatchGetPackages.bind(null, dispatch, props)))
            .then(() => dispatchGetUserPackages(dispatch, props));
    }
    else if (packagesFetched) {
        dispatchGetUserPackages(dispatch, props);
    }
};

const dispatchGetUserPackages = (dispatch, props) => {
    const {userPackagesPending, userPackagesFetched} = props;
    if (!userPackagesPending && !userPackagesFetched) {
        dispatch(getUserPackages(dispatchGetUserPackages.bind(null, dispatch, props)))
            .then(() => dispatchGetMeditations(dispatch, props));
    }
    else if (userPackagesFetched) {
        dispatchGetMeditations(dispatch, props);
    }
};

const dispatchGetMeditations = (dispatch, props) => {
    const {meditationsPending, meditationsFetched} = props;
    if (!meditationsPending && !meditationsFetched) {
        dispatch(getMeditations(dispatchGetMeditations.bind(null, dispatch, props)))
            .then(() => dispatchGetUserData(dispatch, props));
    }
    else if (meditationsFetched) {
        dispatchGetUserData(dispatch, props);
    }
};

const dispatchGetUserData = (dispatch, props) => {
    const {userDataPending, userDataFetched} = props;
    if (!userDataPending && !userDataFetched) {
        dispatch(getUserAction(dispatchGetUserData.bind(null, dispatch, props), 'me'))
            .then(() => dispatchGetUserStats(dispatch, props));
    }
    else if (userDataFetched) {
        dispatchGetUserStats(dispatch, props);
    }
};

const dispatchGetUserStats = (dispatch, props) => {
    const {userStatsPending, userStatsFetched} = props;
    if (!userStatsPending && !userStatsFetched) {
        dispatch(getUserStatsAction(dispatchGetUserStats.bind(null, dispatch, props), 'me'))
            .then(() => dispatchLoadingDone(dispatch, props));
    }
};

const dispatchLoadingDone = (dispatch, props) => dispatch(loadingDone());

const mapDispatchToProps = (dispatch) => {
    return { dispatch }
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(BlankPage);


// WEBPACK FOOTER //
// ./src/components/HigherOrder/BlankPage.js